import React, { createContext, useContext, ReactNode } from "react";
import { useVerifyToken } from "../api/hooks";
import { Account } from "../api";

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  account: Account | null;
  refetch: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { data: account, isLoading, refetch } = useVerifyToken();

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!account,
        isLoading,
        account: account || null,
        refetch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
